import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchApiKey = (brandId, params) => api.request(1, `/getApiKey/${brandId}`, MethodType.GET, params)

export const generateApiKey = params => api.request(1, '/generateApiKey', MethodType.POST, params)

export const regenerateApiKey = (brandId, params) => api.request(1, `/reGenerateApiKey/${brandId}`, MethodType.PATCH, params)

export const revokeApiKey = (brandId, params) => api.request(1, `/revokeApiKey/${brandId}`, MethodType.DELETE, params)
